import React from 'react';
import { Page } from '../Page';
import { Moon, Activity, Droplet } from 'lucide-react';
export function SupplementMagnesium() {
  return <Page pageNumber={31} variant="light" data-id="element-2389">
      <div className="flex h-full gap-10" data-id="element-2390">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2391">
          <img src="https://cdn.magicpatterns.com/uploads/gCYzSDztr2JWuKYmAKzahh/pasted-image.png" alt="Thorne Magnesium Glycinate" className="w-full max-w-[280px] object-contain" data-id="element-2392" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2393">
          <div className="mb-6 pt-4" data-id="element-2394">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2395">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2396">
              Magnesium Glycinate
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2397">
              Sleep, digestion, and metabolic support
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2398" />
          </div>

          <div className="mb-8" data-id="element-2399">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2400">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2401">
              Magnesium glycinate does triple duty for GLP-1 users: supports
              sleep quality, relieves constipation (a very common GLP-1 side
              effect), and enhances insulin sensitivity. The glycinate form is
              calming, well-absorbed, and gentle on the stomach.
            </p>
          </div>

          <div className="mb-8" data-id="element-2402">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2403">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2404">
              <li className="flex gap-2" data-id="element-2405">
                <Moon className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2406" />
                <span data-id="element-2407">
                  Promotes relaxation and deeper sleep, critical for weight loss
                  success
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2408">
                <Droplet className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2409" />
                <span data-id="element-2410">
                  Relieves constipation by drawing water into the intestines
                  (gentle, non-stimulant)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2411">
                <Activity className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2412" />
                <span data-id="element-2413">
                  Supports insulin sensitivity and healthy blood sugar
                  metabolism
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2414">
                <span className="text-tealslate shrink-0" data-id="element-2415">•</span>
                <span data-id="element-2416">
                  120mg per capsule with flexible dosing (1-3 caps) based on
                  individual needs
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2417">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2418">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2419">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2420">
                <strong data-id="element-2421">1-3 capsules daily</strong>. Take in the evening for
                sleep support
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2422">
                120mg magnesium per capsule • Start with 1 cap and adjust as
                needed
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2423">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2424" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2425">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}